import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getHubspotCrmSettings, saveHubspotCrmSettings} from 'src/openapi/admin/apis/HubspotControllerApi';
import {useAppDispatch} from 'src/store/hooks';

import type {HubspotAccountSettings} from 'src/openapi/admin/models/HubspotAccountSettings';

type Props = {
    accountId: number,
};

export const useHubspotSettings = ({accountId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getHubspotCrmSettings({accountId}),
    ), [accountId, apiDispatch]);

    const saveDispatchAction = useCallback(async (hubspotAccountSettings: HubspotAccountSettings) => await apiDispatch(
        saveHubspotCrmSettings({accountId, hubspotAccountSettings}),
    ), [accountId, apiDispatch]);

    return useCommonDataHook({
        getDispatchAction,
        saveDispatchAction,
        shouldLoadData: false,
        initValue: {
            accountSettings: {
                autoLinkEnabled: false,
                autoSyncEnabled: false,
                importEnabled: false,
            },
            contactSettings: {
                autoLinkEnabled: false,
                autoSyncEnabled: false,
                importEnabled: false,
            },
            alertsEnabled: false,
        },
    });
};
